import { z } from "zod/v4"
import { DeviceId, DeviceIdSchema, UserId } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"

export const PlatformSchema = z.enum(["ios", "android", "web"]).describe("プラットフォーム")

export type Platform = z.infer<typeof PlatformSchema>

export const UserDeviceDocumentMeta = z.object({
  device_id: DeviceIdSchema.describe("デバイス ID（UUID、ローカル生成）"),
  platform: PlatformSchema,
  display_name: z.string().optional().describe("ユーザーが編集可能な表示名"),
  last_active_at: z.number().describe("最後にアクティブになった時刻（ミリ秒）"),
  model: z.string().optional().describe("デバイスモデル"),
  ip: z.string().optional().describe("最後にアクセスした際のIPアドレス"),
})

export type UserDeviceDocumentMeta = z.infer<typeof UserDeviceDocumentMeta>

export const UserDeviceDocumentBody = z.intersection(
  UserDeviceDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type UserDeviceDocumentBody = z.infer<typeof UserDeviceDocumentBody>

export type UserDeviceDocument = UserDeviceDocumentBody & {
  id: DeviceId,
  user_id?: UserId,
}

export class UserDeviceDocuments {

  static toDocumentData(doc: UserDeviceDocumentBody): object {
    return {
      ...doc,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): UserDeviceDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    // パスからuser_idを抽出
    // パス構造: /user_privates/{userId}/user_devices/{deviceId}
    const pathParts = doc.ref.path.split("/")
    const userId = 2 <= pathParts.length ? UserId(pathParts[1]) : undefined

    return {
      id: DeviceId(doc.id),
      user_id: userId,
      device_id: data["device_id"],
      platform: data["platform"],
      display_name: data["display_name"],
      last_active_at: data["last_active_at"],
      model: data["model"],
      ip: data["ip"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
